{
    "(save {highestYearlyDiscount}%)": "(ietaupiet {highestYearlyDiscount}%)",
    "{amount} days free": "{amount}\u00a0dienas bez maksas",
    "{amount} off": "{amount} atlaide",
    "{amount} off for first {number} months.": "{amount} atlaide pirmajos {number}\u00a0mēnešos.",
    "{amount} off for first {period}.": "{amount} atlaide pirmajam {period}.",
    "{amount} off forever.": "{amount} atlaide uz visiem laikiem.",
    "{discount}% discount": "{discount}% atlaide",
    "{memberEmail} will no longer receive {newsletterName} newsletter.": "{memberEmail} vairs nesaņems {newsletterName} biļetenu.",
    "{memberEmail} will no longer receive emails when someone replies to your comments.": "{memberEmail} vairs nesaņems e-pasta ziņojumus, kad kāds atbildēs uz jūsu komentāriem.",
    "{memberEmail} will no longer receive this newsletter.": "{memberEmail} vairs nesaņems šo biļetenu.",
    "{memberEmail} will no longer receive updates & announcements.": "",
    "{months} months": "",
    "{months} months free": "",
    "{tierName} membership": "",
    "{trialDays} days free": "{trialDays}\u00a0dienas bez maksas",
    "{years} years": "",
    "+1 (123) 456-7890": "+1 (123) 456-7890",
    "1 month": "",
    "1 month free": "",
    "1 year": "",
    "A gift, just for you": "",
    "Access your RSS feeds": "",
    "Account": "Konts",
    "Account details updated successfully": "Konta informācija ir veiksmīgi atjaunināta",
    "Account settings": "Konta iestatījumi",
    "Add a personal note": "",
    "After a free trial ends, you will be charged the regular price for the tier you've chosen. You can always cancel before then.": "Pēc bezmaksas izmēģinājuma perioda beigām no jums tiks iekasēta parastā cena par jūsu izvēlēto līmeni. Jūs vienmēr varat atcelt pirms tam.",
    "Already a member?": "Vai jau esat dalībnieks?",
    "An error occurred": "Radās kļūda",
    "An unexpected error occured. Please try again or <a>contact support</a> if the error persists.": "Radās neparedzēta kļūda. Lūdzu, mēģiniet vēlreiz vai <a>sazinieties ar atbalsta dienestu</a>, ja kļūda joprojām pastāv.",
    "Back": "Atpakaļ",
    "Back to Log in": "Atpakaļ uz Pieteikties",
    "Before you go": "",
    "Billing info & receipts": "",
    "Black Friday": "Melnā piektdiena",
    "Bluesky": "",
    "Cancel anytime.": "Atcelt jebkurā laikā",
    "Cancel subscription": "Anulēt abonementu",
    "Canceled": "",
    "Cancellation reason": "Atcelšanas iemesls",
    "Change": "Mainīt",
    "Change plan": "Mainīt plānu",
    "Check spam & promotions folders": "Pārbaudiet surogātpasta un reklāmu mapes",
    "Check with your mail provider": "Sazinieties ar savu pasta pakalpojumu sniedzēju",
    "Check your inbox to verify email update": "Pārbaudiet savu iesūtni, lai apstiprinātu e-pasta atjauninājumu",
    "Choose": "Izvēlieties",
    "Choose a different plan": "Izvēlieties citu plānu",
    "Choose a plan": "Izvēlieties plānu",
    "Choose your newsletters": "Izvēlieties savus biļetenus",
    "Click here to retry": "Noklikšķiniet šeit, lai mēģinātu vēlreiz",
    "Click the confirmation link in your inbox to finish redeeming your membership. If it doesn't arrive within 3 minutes, check your spam folder.": "",
    "Close": "Aizvērt",
    "Code": "",
    "Comment preferences updated.": "Komentāru preferences ir atjauninātas.",
    "Comments": "komentāri",
    "Complimentary": "Bezmaksas",
    "Confirm": "Apstiprināt",
    "Confirm cancellation": "Apstipriniet atcelšanu",
    "Confirm subscription": "Apstipriniet abonementu",
    "Contact support": "Sazinieties ar atbalsta dienestu",
    "Continue": "Turpināt",
    "Continue subscription": "Turpināt abonēšanu",
    "Continue with a paid subscription anytime. Your remaining gift period will be added as a free trial.": "",
    "Copied": "",
    "Copy": "",
    "Copy link": "",
    "Could not create Stripe billing portal session": "",
    "Could not create Stripe checkout session": "Nevarēja izveidot Stripe izrakstīšanās sesiju",
    "Could not sign in. Login link expired.": "Nevarēja pierakstīties. Pieteikšanās saites derīguma termiņš ir beidzies.",
    "Could not update email! Invalid link.": "Nevarēja atjaunināt e-pastu! Nederīga saite.",
    "Create a new contact": "Izveidojiet jaunu kontaktu",
    "Current plan": "Pašreizējais plāns",
    "Delete account": "Dzēst kontu",
    "Didn't mean to do this? Manage your preferences <button>here</button>.": "Vai nevēlējāties to darīt? Pārvaldiet savas preferences <button>šeit</button>.",
    "Don't have an account?": "Vai jums nav konta?",
    "Edit": "Rediģēt",
    "Email": "E-pasts",
    "Email confirmation link expired.": "",
    "Email newsletter": "E-pasta biļetens",
    "Email newsletter settings updated": "E-pasta biļetena iestatījumi ir atjaunināti",
    "Email preferences": "E-pasta preferences",
    "Email preferences updated.": "E-pasta preferences atjauninātas.",
    "Emails": "E-pasti",
    "Emails disabled": "E-pasti ir atspējoti",
    "Ends {offerEndDate}": "Beidzas: {offerEndDate}",
    "Enjoy {amountOff} off forever.": "",
    "Enjoy {months} free months on us.": "",
    "Enjoy {months} free months on us. You won't be charged until {newBillingDate}.": "",
    "Enjoy a free month on us.": "",
    "Enjoy a free month on us. You won't be charged until {newBillingDate}.": "",
    "Enter code above": "",
    "Enter your email address": "Ievadiet savu e-pasta adresi",
    "Enter your name": "Ievadiet savu vārdu",
    "Error": "Kļūda",
    "Expires {expiryDate}": "Derīguma termiņš: {expiryDate}",
    "Facebook": "",
    "Failed to cancel subscription, please try again": "Neizdevās atcelt abonementu. Lūdzu, mēģiniet vēlreiz",
    "Failed to log in, please try again": "Neizdevās pieteikties, lūdzu, mēģiniet vēlreiz",
    "Failed to log out, please try again": "Neizdevās atteikties. Lūdzu, mēģiniet vēlreiz",
    "Failed to open billing portal, please try again": "",
    "Failed to process checkout, please try again": "Neizdevās apstrādāt norēķināšanos. Lūdzu, mēģiniet vēlreiz",
    "Failed to send magic link email": "Neizdevās nosūtīt burvju saites e-pasta ziņojumu",
    "Failed to send verification email": "Neizdevās nosūtīt verifikācijas e-pastu",
    "Failed to sign up, please try again": "Neizdevās reģistrēties, lūdzu, mēģiniet vēlreiz",
    "Failed to update account data": "Neizdevās atjaunināt konta datus",
    "Failed to update account details": "Neizdevās atjaunināt konta informāciju",
    "Failed to update billing information, please try again": "",
    "Failed to update newsletter settings": "Neizdevās atjaunināt informatīvā izdevuma iestatījumus",
    "Failed to update subscription, please try again": "Neizdevās atjaunināt abonementu. Lūdzu, mēģiniet vēlreiz",
    "Failed to verify code, please try again": "",
    "Forever": "Uz visiem laikiem",
    "Free Trial – Ends {trialEnd}": "Bezmaksas izmēģinājums\u00a0— beidzas {trialEnd}",
    "Get help": "Saņemiet palīdzību",
    "Get in touch for help": "Sazinieties, lai saņemtu palīdzību",
    "Get notified when someone replies to your comment": "Saņemiet paziņojumu, kad kāds atbild uz jūsu komentāru",
    "Gift a membership": "",
    "Gift could not be redeemed": "",
    "Gift details": "",
    "Gift redeemed! You're all set.": "",
    "Gift subscription": "",
    "Gift subscriptions are not available right now.": "",
    "Gift value": "",
    "Give feedback on this post": "Sniedziet atsauksmes par šo ziņu",
    "Help! I'm not receiving emails": "Palīdziet! Es nesaņemu e-pastus",
    "Here are a few other sites you may enjoy.": "Šeit ir dažas citas vietnes, kas jums varētu patikt.",
    "Hide details": "",
    "If a newsletter is flagged as spam, emails are automatically disabled for that address to make sure you no longer receive any unwanted messages.": "Ja informatīvais izdevums ir atzīmēts kā mēstule, e-pasta ziņojumi šai adresei tiek automātiski atspējoti, lai nodrošinātu, ka vairs nesaņemat nevēlamus ziņojumus.",
    "If the spam complaint was accidental, or you would like to begin receiving emails again, you can resubscribe to emails by clicking the button on the previous screen.": "Ja sūdzība par surogātpastu bija nejauša vai vēlaties atkal saņemt e-pastus, varat atkārtoti abonēt e-pastus, noklikšķinot uz pogas iepriekšējā ekrānā.",
    "If you cancel your subscription now, you will continue to have access until {periodEnd}.": "Ja atcelsiet savu abonementu tagad, jums joprojām būs piekļuve līdz {periodEnd}.",
    "If you have a corporate or government email account, reach out to your IT department and ask them to allow emails to be received from {senderEmail}": "Ja jums ir uzņēmuma vai valdības e-pasta konts, sazinieties ar savu IT nodaļu un lūdziet atļauju saņemt e-pasta ziņojumus no {senderEmail}",
    "If you have an account, a login link has been sent to your inbox. If it doesn't arrive in 3 minutes, be sure to check your spam folder.": "Pieteikšanās saite ir nosūtīta uz jūsu iesūtni. Ja tas nepienāk 3 minūšu laikā, noteikti pārbaudiet surogātpasta mapi.",
    "If you have an account, an email has been sent to {submittedEmailOrInbox}. Click the link inside or enter your code below.": "",
    "If you would like to start receiving emails again, the best next steps are to check your email address on file for any issues and then click resubscribe on the previous screen.": "Ja vēlaties atsākt saņemt e-pasta ziņojumus, labākā nākamā darbība ir pārbaudīt, vai jūsu e-pasta adresē nav problēmu, un pēc tam noklikšķiniet uz atkārtoti abonēt iepriekšējā ekrānā.",
    "If you're not receiving the email newsletter you've subscribed to, here are a few things to check.": "Ja nesaņemat e-pasta biļetenu, kuru esat abonējis, šeit ir dažas lietas, kas jāpārbauda.",
    "If you've completed all these checks and you're still not receiving emails, you can reach out to get support by contacting {supportAddress}.": "Ja esat pabeidzis visas šīs pārbaudes un joprojām nesaņemat e-pasta ziņojumus, varat sazināties, lai saņemtu atbalstu, sazinoties ar {supportAddress}.",
    "In the event a permanent failure is received when attempting to send a newsletter, emails will be disabled on the account.": "Ja, mēģinot nosūtīt biļetenu, tiek saņemta neatgriezeniska kļūme, e-pasta ziņojumi kontā tiks atspējoti.",
    "In your email client add {senderEmail} to your contacts list. This signals to your mail provider that emails sent from this address should be trusted.": "Savā e-pasta klientā pievienojiet {senderEmail} savam kontaktpersonu sarakstam. Tas norāda jūsu pasta pakalpojumu sniedzējam, ka no šīs adreses nosūtītajiem e-pasta ziņojumiem ir jābūt uzticamiem.",
    "Invalid email address": "Nederīga e-pasta adrese",
    "Invalid verification code": "",
    "Jamie Larson": "Džeimijs Larsons",
    "jamie@example.com": "jamie@example.com",
    "Less like this": "Mazāk kā šis",
    "LinkedIn": "",
    "Make sure emails aren't accidentally ending up in the Spam or Promotions folders of your inbox. If they are, click on \"Mark as not spam\" and/or \"Move to inbox\".": "Pārliecinieties, vai e-pasta ziņojumi nejauši nenonāk jūsu iesūtnes mapē Mēstules vai Reklāmas. Ja tie ir, noklikšķiniet uz \"Atzīmēt kā ne surogātpastu\" un/vai \"Pārvietot uz iesūtni\".",
    "Manage": "Pārvaldīt",
    "Maybe later": "Varbūt vēlāk",
    "Membership details": "",
    "Memberships from this email domain are currently restricted.": "",
    "Memberships unavailable, contact the owner for access.": "Dalība nav pieejama. Lai iegūtu piekļuvi, sazinieties ar īpašnieku.",
    "month": "mēnesis",
    "Monthly": "Ikmēneša",
    "More like this": "Vairāk kā šis",
    "More options": "",
    "Name": "Vārds",
    "Need more help? Contact support": "Vai nepieciešama papildu palīdzība? Sazinieties ar atbalsta dienestu",
    "Newsletters can be disabled on your account for two reasons: A previous email was marked as spam, or attempting to send an email resulted in a permanent failure (bounce).": "Informatīvos izdevumus jūsu kontā var atspējot divu iemeslu dēļ: iepriekšējais e-pasts tika atzīmēts kā mēstule vai mēģinājums nosūtīt e-pastu izraisīja neatgriezenisku kļūmi (bounce).",
    "No member exists with this e-mail address.": "Nav neviena dalībnieka ar šo e-pasta adresi.",
    "No thanks, I want to cancel": "",
    "Not ready to share? We've also emailed a copy to your inbox.": "",
    "Not receiving emails?": "Vai nesaņemat e-pastus?",
    "Now check your email!": "Tagad pārbaudiet savu e-pastu!",
    "Occasional updates from {siteTitle}": "",
    "Once resubscribed, if you still don't see emails in your inbox, check your spam folder. Some inbox providers keep a record of previous spam complaints and will continue to flag emails. If this happens, mark the latest newsletter as 'Not spam' to move it back to your primary inbox.": "Ja pēc atkārtotas abonēšanas iesūtnē joprojām neredzat e-pasta ziņojumus, pārbaudiet surogātpasta mapi. Daži iesūtnes pakalpojumu sniedzēji reģistrē iepriekšējās surogātpasta sūdzības un turpinās atzīmēt e-pastus. Ja tā notiek, atzīmējiet jaunāko biļetenu kā “Nav mēstules”, lai pārvietotu to atpakaļ uz savu primāro iesūtni.",
    "Open AOL Mail": "",
    "Open email": "",
    "Open Feedbin": "",
    "Open Gmail": "",
    "Open Hey": "",
    "Open iCloud Mail": "",
    "Open Mail.ru": "",
    "Open Outlook": "",
    "Open Proton Mail": "",
    "Open Yahoo Mail": "",
    "Permanent failure (bounce)": "Pastāvīga kļūme (bounce)",
    "Phone number": "Tālruņa numurs",
    "Plan": "Plāns",
    "Plan checkout was cancelled.": "Plāna izrakstīšanās tika atcelta.",
    "Plan upgrade was cancelled.": "Plāna jaunināšana tika atcelta.",
    "Please contact {supportAddress} to adjust your complimentary subscription.": "Lūdzu, sazinieties ar {supportAddress}, lai pielāgotu savu bezmaksas abonementu.",
    "Please enter {fieldName}": "Lūdzu, ievadiet {fieldName}",
    "Please fill in required fields": "Lūdzu, aizpildiet obligātos laukus",
    "Podcasts": "",
    "Re-enable emails": "Atkārtoti iespējot e-pastus",
    "Recommendations": "Ieteikumi",
    "Redeem your membership": "",
    "Redeeming...": "",
    "Renews at {price}.": "Atjauno par {price}",
    "Resume subscription": "",
    "Retry": "Mēģiniet vēlreiz",
    "Save": "Saglabāt",
    "Save {amountOff} on your next {durationInMonths} billing cycles. Then {currency}{originalPrice}/{cadence}.": "",
    "Save {amountOff} on your next billing cycle. Then {currency}{originalPrice}/{cadence}.": "",
    "Send the link below to share it with whoever you'd like.": "",
    "Sending login link...": "Notiek pieteikšanās saites sūtīšana...",
    "Sending...": "Notiek sūtīšana...",
    "Share": "",
    "Share a full membership to {siteTitle} with a friend or colleague": "",
    "Show all": "Rādīt visu",
    "Sign in": "Pierakstīties",
    "Sign out": "Izrakstīties",
    "Sign up": "Pierakstīties",
    "Signup error: Invalid link": "Reģistrācijas kļūda: nederīga saite",
    "Signups from this email domain are currently restricted.": "",
    "Something went wrong, please try again later.": "Radās problēma. Lūdzu, vēlāk mēģiniet vēlreiz.",
    "Sorry, no paid plans are available.": "",
    "Sorry, no recommendations are available right now.": "Diemžēl pašlaik ieteikumi nav pieejami.",
    "Sorry, that didn’t work.": "Atvainojiet, tas nedarbojās.",
    "Spam complaints": "Surogātpasta sūdzības",
    "Start {amount}-day free trial": "Sāciet {amount}\u00a0dienu bezmaksas izmēģinājumu",
    "Starting {startDate}": "Sākot no {startDate}",
    "Starting today": "Sākot no šodienas",
    "Submit feedback": "Iesniedziet atsauksmes",
    "Subscribe": "Abonēt",
    "Subscribed": "Abonēts",
    "Subscription plan updated successfully": "Abonēšanas plāns ir veiksmīgi atjaunināts",
    "Success": "Veiksmīgi!",
    "Success! Check your email for magic link to sign-in.": "Veiksmi! Pārbaudiet, vai savā e-pastā nav maģiskas saites, lai pierakstītos.",
    "Success! Your account is fully activated, you now have access to all content.": "Veiksmi! Jūsu konts ir pilnībā aktivizēts, tagad jums ir piekļuve visam saturam.",
    "Success! Your email is updated.": "Veiksmi! Jūsu e-pasts ir atjaunināts.",
    "Successfully unsubscribed": "Veiksmīgi anulēts abonements",
    "Thank you for subscribing. Before you start reading, below are a few other sites you may enjoy.": "Paldies par abonēšanu. Pirms sākat lasīt, tālāk ir norādītas dažas citas vietnes, kas jums varētu patikt.",
    "Thank you for your support": "Paldies par atbalstu",
    "Thank you for your support!": "Paldies par atbalstu!",
    "Thanks for the feedback!": "Paldies par atsauksmi!",
    "That didn't go to plan": "Tas negāja pēc plāna",
    "The email address we have for you is {memberEmail} — if that's not correct, you can update it in your <button>account settings area</button>.": "Mūsu e-pasta adrese ir {memberEmail} — ja tā nav pareiza, varat to atjaunināt savā <button>konta iestatījumu apgabalā</button>.",
    "There was a problem submitting your feedback. Please try again a little later.": "Mūsu e-pasta adrese ir {membermail} — ja tā nav pareiza, varat atjaunināt savā <button>konta pasta apgabalā</button>.",
    "There was an error cancelling your subscription, please try again.": "Atceļot abonementu, radās kļūda. Lūdzu, mēģiniet vēlreiz.",
    "There was an error continuing your subscription, please try again.": "Turpinot abonementu, radās kļūda. Lūdzu, mēģiniet vēlreiz.",
    "There was an error processing your payment. Please try again.": "Apstrādājot jūsu maksājumu, radās kļūda. Lūdzu, mēģiniet vēlreiz.",
    "There was an error sending the email, please try again": "Nosūtot e-pasta ziņojumu, radās kļūda. Lūdzu, mēģiniet vēlreiz",
    "This gift has already been consumed.": "",
    "This gift has already been redeemed.": "",
    "This gift has been refunded.": "",
    "This gift has expired.": "",
    "This site is invite-only, contact the owner for access.": "Šī vietne ir paredzēta tikai ielūgumam. Lai iegūtu piekļuvi, sazinieties ar īpašnieku.",
    "This site is not accepting donations at the moment.": "",
    "This site is not accepting payments at the moment.": "Šī vietne pašlaik nepieņem maksājumus.",
    "This site only accepts paid members.": "",
    "Threads": "",
    "Tier": "",
    "To complete signup, click the confirmation link in your inbox. If it doesn't arrive within 3 minutes, check your spam folder!": "Lai pabeigtu reģistrāciju, iesūtnē noklikšķiniet uz apstiprinājuma saites. Ja tas nepienāk 3 minūšu laikā, pārbaudiet savu surogātpasta mapi!",
    "To continue to stay up to date, subscribe to {publication} below.": "Lai turpinātu saņemt jaunāko informāciju, abonējiet tālāk norādīto {publication}.",
    "Too many attempts try again in {number} days.": "Pārāk daudz mēģinājumu mēģiniet vēlreiz pēc {number} dienām.",
    "Too many attempts try again in {number} hours.": "Pārāk daudz mēģinājumu mēģiniet vēlreiz pēc {number}\u00a0stundām.",
    "Too many attempts try again in {number} minutes.": "Pārāk daudz mēģinājumu mēģiniet vēlreiz pēc {number}\u00a0minūtēm.",
    "Too many different sign-in attempts, try again in {number} days": "Pārāk daudz dažādu pierakstīšanās mēģinājumu, mēģiniet vēlreiz pēc {number}\u00a0dienām",
    "Too many different sign-in attempts, try again in {number} hours": "Pārāk daudz dažādu pierakstīšanās mēģinājumu. Mēģiniet vēlreiz pēc {number}\u00a0stundām",
    "Too many different sign-in attempts, try again in {number} minutes": "Pārāk daudz dažādu pierakstīšanās mēģinājumu, mēģiniet vēlreiz pēc {number}\u00a0minūtēm",
    "Too many sign-up attempts, try again later": "",
    "Try free for {amount} days, then {originalPrice}.": "Mēģiniet bez maksas {amount}\u00a0dienas, pēc tam {originalPrice}.",
    "Unable to initiate checkout session": "Nevar uzsākt norēķināšanās sesiju",
    "Unlock access to all newsletters by becoming a paid subscriber.": "Atbloķējiet piekļuvi visiem biļeteniem, kļūstot par maksas abonentu.",
    "Unsubscribe from all emails": "Anulēt visu e-pasta ziņojumu abonēšanu",
    "Unsubscribed": "Anulēts abonements",
    "Unsubscribed from all emails.": "Anulēts visu e-pasta ziņojumu abonements.",
    "Unsubscribing from emails will not cancel your paid subscription to {title}": "E-pasta abonēšanas anulēšana neatcels jūsu maksas abonementu {title}",
    "Update": "Atjaunināt",
    "Update your preferences": "Atjauniniet savas preferences",
    "Updates & announcements": "",
    "Verification link sent, check your inbox": "Pārbaudes saite ir nosūtīta, pārbaudiet iesūtni",
    "Verify your email address is correct": "Pārbaudiet, vai jūsu e-pasta adrese ir pareiza",
    "Verifying...": "",
    "View plans": "Skatīt plānus",
    "We couldn't unsubscribe you as the email address was not found. Please contact the site owner.": "Mēs nevarējām anulēt jūsu abonementu, jo e-pasta adrese netika atrasta. Lūdzu, sazinieties ar vietnes īpašnieku.",
    "We'd hate to see you leave. How about a special offer to stay?": "",
    "Welcome back, {name}!": "Laipni lūdzam atpakaļ, {name}!",
    "Welcome back!": "Laipni lūdzam atpakaļ!",
    "Welcome to {siteTitle}": "Laipni lūdzam vietnē {siteTitle}",
    "When an inbox fails to accept an email it is commonly called a bounce. In many cases, this can be temporary. However, in some cases, a bounced email can be returned as a permanent failure when an email address is invalid or non-existent.": "Ja iesūtne nepieņem e-pasta ziņojumu, to parasti sauc par atlēcienu. Daudzos gadījumos tas var būt īslaicīgs. Tomēr dažos gadījumos atlaists e-pasts var tikt atgriezts kā neatgriezeniska kļūme, ja e-pasta adrese nav derīga vai tās nav.",
    "Why has my email been disabled?": "Kāpēc mans e-pasts ir atspējots?",
    "X (Twitter)": "",
    "year": "gads",
    "Yearly": "Ik gadu",
    "You already have an active subscription.": "",
    "You currently have a free membership, upgrade to a paid subscription for full access.": "Pašlaik jums ir bezmaksas dalība. Lai iegūtu pilnu piekļuvi, jauniniet uz maksas abonementu.",
    "You have been successfully resubscribed": "Jūs esat veiksmīgi atkārtoti abonējis",
    "You now have access to {tierName} until {expiryDate}. Enjoy!": "",
    "You're currently not receiving emails": "Pašlaik jūs nesaņemat e-pasta ziņojumus",
    "You're not receiving emails": "Jūs nesaņemat e-pasta ziņojumus",
    "You're not receiving emails because you either marked a recent message as spam, or because messages could not be delivered to your provided email address.": "Jūs nesaņemat e-pasta ziņojumus, jo nesen kādu ziņojumu esat atzīmējis kā surogātpastu, vai arī tāpēc, ka ziņojumus nevarēja piegādāt uz jūsu norādīto e-pasta adresi.",
    "You've been gifted a membership": "",
    "You've been gifted a membership to {siteTitle}": "",
    "You've successfully signed in.": "Jūs esat veiksmīgi pierakstījies.",
    "You've successfully subscribed to <strong>{siteTitle}</strong>": "Jūs esat veiksmīgi abonējis <strong>{siteTitle}</strong>",
    "Your account": "Jūsu konts",
    "Your email": "",
    "Your email has failed to resubscribe, please try again": "Jūsu e-pasta abonēšana neizdevās atkārtoti. Lūdzu, mēģiniet vēlreiz",
    "Your gift is ready": "",
    "Your gift subscription will expire on {expiryDate}": "",
    "your inbox": "",
    "Your input helps shape what gets published.": "Jūsu ieguldījums palīdz veidot publicējamo saturu.",
    "Your name": "",
    "Your subscription has been canceled and will expire on {expiryDate}.": "",
    "Your subscription will expire on {expiryDate}": "Jūsu abonementa derīguma termiņš beigsies {expiryDate}",
    "Your subscription will renew on {renewalDate}": "Jūsu abonements tiks atjaunots šādā datumā: {renewalDate}",
    "Your subscription will start on {subscriptionStart}": "Jūsu abonements sāksies šādā datumā: {subscriptionStart}"
}
